import Http from "@/commons/Http";
import PDFBusiness from "@/business/PDFBusiness";
import ZipBusiness from "@/business/ZipBusiness";
import Utils from "@/utils/Utils";

const path = 'api/protocol';

export default {

    async save(dto, id = ''){
        if(Utils.isEmptyNullOrUndefined(id)){
            dto.publicAccessCode = this.generateAccessCode();
        }
        return Http.post(`${path}/${id}`, dto);
    },

    async saveQuickProtocol(dto){
        dto.publicAccessCode = this.generateAccessCode();
        return Http.post(`${path}/create-quick-protocol`, dto);
    },

    async getById(id){
        return Http.get(`${path}/${id}`);
    },

    async audit(sort, direction, page, size){
        const filters = {entity: "Protocol"};
        return Http.post(`${path}/audit?sort=${sort || 'a.created'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    async pagination(sort, direction, page, size, filters = {}){
        return Http.post(`${path}/pagination?sort=${sort || 'p.code'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    protocolName(protocol){
        if(protocol.budget){
            return `${this.$t('forms.protocol.budget-title')} ${protocol.code}`;
        }
        return `${this.$t('forms.protocol.title')} ${protocol.code}`;
    },

    async saveTypeOfServiceProtocol(dto, protocolId = '', serviceProtocolId = ''){
        return Http.post(`${path}/${protocolId}/save-type-of-service/${serviceProtocolId}`, dto);
    },

    async deleteTypeOfServiceProtocol(protocolId = '', serviceProtocolId){
        return Http.delete(`${path}/${protocolId}/delete-type-of-service/${serviceProtocolId}`);
    },

    async servicesOfProtocol(id){
        return Http.get(`${path}/${id}/services`);
    },

    async saveProtocolClient(dto, protocolId = '', protocolClientId = ''){
        return Http.post(`${path}/${protocolId}/save-protocol-client/${protocolClientId}`, dto);
    },

    async deleteProtocolClient(protocolId = '', protocolClientId){
        return Http.delete(`${path}/${protocolId}/delete-protocol-client/${protocolClientId}`);
    },

    async clientsOfProtocol(id){
        return Http.get(`${path}/${id}/clients`);
    },

    async calculatePriceTypeOfServiceProtocol(protocolId, protocolTypeService){
        return Http.post(`${path}/${protocolId}/calculate-price`, protocolTypeService);
    },

    async getServicesOfClient(protocolId, clientId){
        return Http.get(`${path}/${protocolId}/client/${clientId}`);
    },

    async getServicesOfUnderageClients(protocolId){
        return Http.get(`${path}/${protocolId}/underage-clients`);
    },

    async printBudget(protocolId, htmlBudget){
        const url = `${path}/${protocolId}/print/pdfbudget`;
        return await PDFBusiness.showPdf(url, htmlBudget);
    },

    async printPdfBudget(protocolId, selectedProtocols){
        const url = `${path}/${protocolId}/print/pdfbudget2`;
        return await PDFBusiness.showPdf(url, selectedProtocols, 'POST', 'application/json');
    },

    async getHtmlBudget(protocolId){
        return Http.get(`${path}/${protocolId}/print/htmlbudget`);
    },

    async printContracts(protocol, totalPricePerClientDTO){
        const url = `${path}/${protocol.id}/print/contracts`;
        const filename = "Contratos "+protocol.familyName +".zip";
        return await ZipBusiness.downloadZip(url, totalPricePerClientDTO, filename);
    },

    async reactive(protocolId){
        return Http.post(`${path}/${protocolId}/action/reactive`);
    },

    async budgetToProtocol(protocolId){
        return Http.post(`${path}/${protocolId}/action/budget-to-protocol`);
    },

    async finalize(protocolId){
        return Http.post(`${path}/${protocolId}/action/finalize`);
    },

    async cancel(protocolId){
        return Http.post(`${path}/${protocolId}/action/canceled`);
    },

    async forward(protocolId, user){
        return Http.post(`${path}/${protocolId}/action/forward`, user);
    },

    async getPricePerPerson(protocolId){
        return Http.get(`${path}/${protocolId}/price-per-person`);
    },

    async getTotalPricePerPerson(protocolId){
        return Http.get(`${path}/${protocolId}/total-price-per-person`);
    },

    async sendProcess(protocolId, trackingCode){
        return Http.post(`${path}/${protocolId}/send-process/${trackingCode}`);
    },

    async cancelSendProcess(protocolId){
        return Http.post(`${path}/${protocolId}/send-process/cancel`);
    },

    generateAccessCode(){
        return (Math.random() * 100000000).toString().replace('.', '').substring(0, 6);
    },

    async search(code){
        if(Utils.isEmptyNullOrUndefined(code)) {
            return null;
        }
        return Http.get(`${path}/s/10?code=${code}`);
    },

}
